/*
 * @Description: 系统日志
 * @Author: gao shuai
 * @Date: 2020-02-25 15:36:33
 * @LastEditTime: 2020-04-18 11:24:07
 * @LastEditors: gao shuai
 */
import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  // 日志列表
  async loglist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageLog/GetLogPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 日志清除
  async logclear(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageLog/ClearLog',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  }
};
